// External imports
import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Image, Form, Modal } from "react-bootstrap";
import {
	IoMdPerson,
	IoMdLock,
	IoMdUnlock,
	IoMdDoneAll,
	IoIosClose,
} from "react-icons/io";
// import axios from 'axios'

// Local imports
// import logoIcon from "../../assets/images/logo-icon.png";
import logoIcon from "../../assets/images/fat-favicon.png";

import { loginSuccess, getUsersFailure } from "../../actions/user/userActions";
import { _HttpServices } from "../../_services/_HttpServices";
import { Toast } from "react-bootstrap";
import Loader from "../../components/Loader";
// import validator from 'validator';
var message;
let userId;
const LoginPage = ({ dispatch, login, hasErrors }) => {
	const intialstate = {
		oldPassword: "",
		newPassword: "",
		confirmPassword: "",
	};
	const [show, setShow] = useState(false);

	const [showToaster, setShowToaster] = useState(false);
	const initialState = { username: "", password: "" };
	const [loginCheck, setLoginCheck] = useState(initialState);
	const [disable, setDisable] = useState(true);
	const forgot_pw = { username: "", emailID: "" };
	const [forgotPassword, setForgotPassword] = useState(forgot_pw);
	const [validate, setValidated] = useState(false);
	const history = useHistory();
	const [wrongDetails, setWrongDetails] = useState(false);
	const [validatedChange, setValidatedChange] = useState(false);
	const [isPwdMatch, setIsPwdMatch] = useState(false);
	const [changePassword, setChangePassword] = useState(intialstate);
	//   const [userPassword, setUserPassword] = useState("");
	const [isFirstLogin, setIsFirstLogin] = useState(false);
	const [isChangeDisable, setIsChangeDisable] = useState(true);
	const [submitDisabled, setSubmitDisabled] = useState(true);
	const [loading, setLoading] = useState(false);
	const [isPwdRegex, setIsPwdRegex] = useState(false);
	const [isOldPwdWrong, setIsOldPwdWrong] = useState(false);
	const [version, setVersion] = useState({});
	const [editingErrorToaster, setEditingErrorToaster] = useState(false);
	// const [data, setData] = useState(null);

	const userData = JSON.parse(localStorage.getItem("userData"));

	useEffect(() => {
		getVersion();
		// Dashboard routing
		if (localStorage.getItem("userData") && userData.IsFirstLogin) {
			setIsFirstLogin(false);
		} else if (
			localStorage.getItem("userData") &&
			userData.IsFirstLogin === false
		) {
			dispatch(loginSuccess());
			history.push("/dashboard");
		}
		// return () => {
		//   if (localStorage.getItem('userData') && userData?.IsFirstLogin) {
		//     // alert("isFistLogin")
		//     // alert("isFistLogin", JSON.stringify(data))
		//     localStorage.removeItem("userData")
		//     history.push('/')
		//   }
		// }
	}, []);

	useEffect(() => {
		const enableLogin = () => {
			if (loginCheck.username.length > 0 && loginCheck.password.length > 0) {
				setDisable(false);
			} else {
				setDisable(true);
			}
		};
		const updateLogincheck = (loginCheck) => {
			enableLogin();
		};
		updateLogincheck(loginCheck);
	}, [dispatch, history, loginCheck]);

	/** To get application version */
	const getVersion = () => {
		setLoading(true);
		_HttpServices
			.getData("/api/client/VersionData")
			.then((response) => {
				setVersion(response.data);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
			});
	};
	const handleClose = () => {
		console.log(forgotPassword);
		setForgotPassword(forgot_pw);
		setShow(false);
		setValidated(false);
		setSubmitDisabled(true);
	};

	const handleShow = () => setShow(true);
	// Login fn
	const handleInputChange = (event) => {
		const { name, value } = event.target;

		setLoginCheck({ ...loginCheck, [name]: value.trim() });
		setWrongDetails(false);
		// enableLogin();
	};
	const handleInputChange_pw = (event) => {
		// const {name, value} = event.target
		// const re = /^[a-zA-Z]*$/;
		const re = /^[a-zA-Z0-9_]*$/;
		if (event.target.value === "" || re.test(event.target.value)) {
			setForgotPassword({
				...forgotPassword,
				[event.target.name]: event.target.value.trim(),
			});
		}
		if (event.target.value.trim().length === 0) setSubmitDisabled(true);
		else setSubmitDisabled(false);
	};
	const loginHandle = async () => {
		try {
			setLoading(true);
			// const response = await axios.get('http://localhost:4003/auth');
			// const data = response.data
			// const login = data.login
			if (loginCheck.username && loginCheck.password) {
				// axios.put("http://localhost:4003/auth", {
				//     ...data, login: !login
				// }).then(res => {
				//     dispatch(loginSuccess())
				//     localStorage.setItem('loggedIn', true)
				//     history.push('/dashboard')
				// })
				_HttpServices
					.postData(
						`Api/User/Login?username=${loginCheck.username}&password=${loginCheck.password}`,
						{}
					)
					.then((res) => {
						login = !login;
						if (res.data !== undefined && res.data.IsFirstLogin) {
							setIsFirstLogin(true);
							userId = res.data.Id;
							localStorage.setItem("userData", JSON.stringify(res.data));
							// setData(res.data);
							setLoading(false);
						} else {
							setIsFirstLogin(false);

							localStorage.setItem("loggedIn", true);
							localStorage.setItem("userData", JSON.stringify(res.data));
							// setData(res.data);
							localStorage.setItem("products", []);
							localStorage.setItem("contacts", []);
							localStorage.setItem("barColors", []);
							localStorage.setItem("barLabels", []);
							localStorage.setItem("clients", []);
							localStorage.removeItem("Shipment");
							localStorage.removeItem("SalesOrer");
							localStorage.removeItem("GoodsReceipts");
							localStorage.removeItem("dataSync");
							setLoading(false);
							history.push("/dashboard");
							dispatch(loginSuccess());
						}
						console.log(res.data.IsFirstLogin);
						setWrongDetails(false);
					})
					.catch((e) => {
						if (e !== undefined && e.response !== undefined) {
							console.log(e.response.data.Message);
							setWrongDetails(true);
						}
						setLoading(false);
						setWrongDetails(true);
					});
			} else {
				setLoading(false);
				dispatch(getUsersFailure());
			}
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};
	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			loginHandle();
		}
	};
	const forgotPasswordHandle = async (event) => {
		const form = event.currentTarget;
		event.preventDefault();
		// setValidated(true);
		if (forgotPassword.username !== "") {
			setLoading(true);
			_HttpServices
				.postData(`Api/user/forgotpassword`, {
					username: forgotPassword.username,
				})
				.then((data) => {
					message =
						"Password recovered successfully and sent to registered Email ID";
					setLoading(false);
					setShowToaster(true);
					setShow(false);
					setEditingErrorToaster(false);
					setForgotPassword(forgot_pw);
					history.push("/");
					setSubmitDisabled(true);
					// }
				})
				.catch((e) => {
					console.log(e.response.data.Message);
					message = e.response.data.Message;
					setEditingErrorToaster(true);
					setShowToaster(true);
					setShow(true);
					setValidated(false);
					setLoading(false);
					// setForgotPassword(forgot_pw);
				});
		} else {
			if (form.checkValidity() === false) {
				event.preventDefault();
				event.stopPropagation();
			}
			setValidated(true);
			setSubmitDisabled(true);
		}
	};
	const handleChangePwdInputChange = (event) => {
		const { name, value } = event.target;
		if (
			changePassword.confirmPassword !== "" &&
			changePassword.oldPassword !== "" &&
			changePassword.newPassword !== ""
		) {
			setIsChangeDisable(false);
		} else {
			setIsChangeDisable(true);
		}
		if (name === "newPassword") {
			const re =
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
			if (re.test(value)) {
				setIsPwdRegex(false);
			} else {
				setIsPwdRegex(true);
			}
		}
		setChangePassword({ ...changePassword, [name]: value });
		if (
			changePassword.oldPassword.trim() !== "" &&
			changePassword.newPassword.trim() !== "" &&
			changePassword.confirmPassword.trim() !== ""
		) {
			setIsChangeDisable(false);
		} else {
			setIsChangeDisable(true);
		}
	};
	const handleOnCancelChangePassword = () => {
		setValidatedChange(false);
		setIsFirstLogin(false);
		setChangePassword(intialstate);
		setIsOldPwdWrong(false);
		setIsPwdMatch(false);
		localStorage.removeItem("userData");
	};
	const submitHandler = (event) => {
		const form = event.currentTarget;
		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
		}

		event.preventDefault();
		if (changePassword.oldPassword !== "") {
			setIsOldPwdWrong(false);
			if (changePassword.newPassword === changePassword.confirmPassword) {
				setIsPwdMatch(false);
				const formModel = {
					existingPassword: changePassword.oldPassword,
					userId: userId,
					NewPassword: changePassword.newPassword,
				};
				if (isPwdRegex) {
					return false;
				}
				setLoading(true);
				_HttpServices
					.postData(
						`Api/user/ChangePassword?existingPassword=${formModel.existingPassword}&&userId=${formModel.userId}&&NewPassword=${formModel.NewPassword}`,
						{}
					)
					.then((data) => {
						if (data.data !== "") {
							message = "Password Changed Succesfully";
							setChangePassword(intialstate);
							setShowToaster(true);
							setIsFirstLogin(false);
							setIsOldPwdWrong(false);
							setLoading(false);
						} else {
							setShowToaster(false);
							setLoading(false);
						}
					})
					.catch((e) => {
						setIsOldPwdWrong(true);
						setLoading(false);
						console.log(e);
					});
			} else {
				setIsPwdMatch(true);
			}
		} else {
			setValidatedChange(true);
			setIsOldPwdWrong(false);
		}
	};

	return (
		<section className="login-page">
			{/* Toaster */}
			{loading ? <Loader /> : null}
			<Toast
				className={editingErrorToaster ? "err-toaster" : "custom-toaster"}
				onClose={() => setShowToaster(false)}
				show={showToaster}
				delay={2500}
				autohide
				// className="custom-toaster error-toaster"
			>
				{/* <Toast.Header> */}
				{/* <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" /> */}
				{/* <strong className="mr-auto">{editingErrorToaster ?"Error":"Woohoo!!" }</strong> */}
				{/* </Toast.Header> */}
				<Toast.Body>{message}</Toast.Body>
			</Toast>
			<div className="pos-rl login-wrap">
				<div className="login-logo-wrap">
					<div className="login-logo-inner">
						<Image src={logoIcon} alt="Logo Icon" className="login-logo" />
					</div>
				</div>
				{!isFirstLogin && (
					<Fragment>
						<Form className="login-form" onKeyPress={handleKeyPress}>
							<h3 className="h3 mb-4 text-center">Login</h3>

							<Form.Group className="pos-rl mb-4">
								<Form.Control
									type="text"
									placeholder="Username"
									name="username"
									onChange={handleInputChange}
									onBlur={handleInputChange}
									maxLength={50}
								/>
								<IoMdPerson className="icon" color="#3B61AD" />
							</Form.Group>
							<Form.Group className="pos-rl mb-4">
								<Form.Control
									type="password"
									placeholder="Password"
									name="password"
									onChange={handleInputChange}
									onBlur={handleInputChange}
									maxLength={50}
								/>
								<IoMdLock className="icon" color="#3B61AD" />
							</Form.Group>
							{wrongDetails ? (
								<p className="text-center err-msg">
									Please enter valid username and password.
								</p>
							) : null}
							<div className="text-center form-btns">
								<Button
									variant="primary"
									onClick={() => loginHandle()}
									disabled={disable}
									className="btn-lg"
								>
									<IoMdUnlock className="icon mr-1 btn-icon-top-align" />
									Login
								</Button>
							</div>
							<div className="forgot-pwd text-center mt-3">
								<Button
									variant="link"
									onClick={handleShow}
									className="link-btn"
								>
									Forgot Password?
								</Button>
							</div>
							<div className="text-center fs-12 mt-3">
								<span>
									Version:{" "}
									{version.VersionNumberID == null
										? null
										: (version.VersionNumberID * 1).toFixed(1)}
								</span>
							</div>
						</Form>
					</Fragment>
				)}
				{isFirstLogin && (
					<Fragment>
						<Form
							className="login-form"
							noValidate
							validated={validatedChange}
							onSubmit={submitHandler}
						>
							<h3 className="h3 mb-4 text-center">Change Password</h3>

							<Form.Group className="pos-rl mb-4">
								{/* <Form.Label htmlFor="oldPassword">
                        Old Password
                      </Form.Label> */}
								<Form.Control
									type="password"
									required
									name="oldPassword"
									onChange={handleChangePwdInputChange}
									value={changePassword.oldPassword}
									placeholder="Old Password"
									className={isOldPwdWrong ? "is-invalid" : null}
									maxLength={50}
								/>
								<IoMdLock className="icon" color="#3B61AD" />
								{isOldPwdWrong && (
									<Form.Control.Feedback type="invalid">
										Incorrect Password.
									</Form.Control.Feedback>
								)}
								{!isOldPwdWrong && (
									<Form.Control.Feedback type="invalid">
										Old password is required.
									</Form.Control.Feedback>
								)}
							</Form.Group>
							<Form.Group className="pos-rl mb-4">
								{/* <Form.Label htmlFor="newPassword">
                        New Password
                      </Form.Label> */}
								<Form.Control
									type="password"
									required
									name="newPassword"
									onChange={handleChangePwdInputChange}
									value={changePassword.newPassword}
									placeholder="New Password"
									className={isPwdRegex ? "is-invalid" : null}
									maxLength={50}
								/>
								<IoMdLock className="icon" color="#3B61AD" />
								<Form.Text id="newPassword" muted>
									New password should be minimum 8 characters with a mixture of
									upper case & lower case letters, one numeric and one special
									character.
								</Form.Text>
								{!isPwdRegex && (
									<Form.Control.Feedback type="invalid">
										New password is required.
									</Form.Control.Feedback>
								)}
								{isPwdRegex && (
									<Form.Control.Feedback type="invalid">
										{/* New password is not meeting requirement. */}
										{/* Entered "New password" is not meeting the above rules. */}
										Your password does not satisfy the current policy
										requirements.
									</Form.Control.Feedback>
								)}
							</Form.Group>
							<Form.Group className="pos-rl mb-4">
								{/* <Form.Label htmlFor="confirmPassword">
                        Confirm Password
                      </Form.Label.> */}
								<Form.Control
									type="password"
									required
									name="confirmPassword"
									onChange={handleChangePwdInputChange}
									value={changePassword.confirmPassword}
									placeholder="Confirm Password"
									maxLength={50}
								/>
								<IoMdLock className="icon" color="#3B61AD" />
								{!isPwdMatch && (
									<Form.Control.Feedback type="invalid">
										{/* Confirm password is not matched. */}
										New password and Confirm password should be same.
									</Form.Control.Feedback>
								)}
								{isPwdMatch && (
									<p className="err-msg">
										{/* Confirm password is not matched. */}
										New password and Confirm password should be same.
									</p>
								)}
							</Form.Group>

							<Form.Group className="text-right mt-4">
								<Button type="submit">
									<IoMdDoneAll
										className=" btn-icon"
										disabled={isChangeDisable}
									/>
									Submit
								</Button>

								<Button
									variant="danger"
									className="ml-3"
									onClick={handleOnCancelChangePassword}
								>
									<IoIosClose className="btn-icon" />
									Cancel
								</Button>
							</Form.Group>
						</Form>
					</Fragment>
				)}
			</div>
			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Forgot Password </Modal.Title>
				</Modal.Header>

				<Form
					className=""
					validated={validate}
					onSubmit={(e) => forgotPasswordHandle(e)}
					noValidate
				>
					<Modal.Body>
						{/* <h3 className="h3 mb-4 text-center">Login</h3> */}
						{/* {hasErrors ? <p className="text-center err-msg">Plase enter valid username and password.</p> : null} */}
						<Form.Group className="pos-rl mb-4">
							<Form.Label>
								Username<span className="required">*</span>
							</Form.Label>
							<Form.Control
								type="text"
								placeholder="Username"
								required
								name="username"
								value={forgotPassword.username}
								onChange={handleInputChange_pw}
								maxLength={50}
							/>
							{/* <IoMdPerson className="icon" color="#3B61AD" /> */}
							{/* {errors.username ? <p className="err-msg">{errors.username}</p> : null} */}
							<Form.Control.Feedback type="invalid">
								Username is required.
							</Form.Control.Feedback>
						</Form.Group>
						{/* <Form.Group className="pos-rl mb-4">
            <Form.Label>Email ID<span className="required">*</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Email ID"
                required
                name="emailID"
                onChange={handleInputChange_pw}
              />
              
              <Form.Control.Feedback type="invalid">
                EmailID is required.
              </Form.Control.Feedback>
            </Form.Group> */}
						{/* <div className="text-center form-btns">
                        <Button variant="primary" onClick={() => loginHandle()} disabled={disable} className="btn-lg"><IoMdUnlock className="icon mr-1" />Login</Button>
                    </div> */}
					</Modal.Body>
					<Modal.Footer>
						{/* onClick={forgotPasswordHandle} */}
						<div className="text-right">
							<Button variant="primary" disabled={submitDisabled} type="submit">
								<IoMdDoneAll className="icon btn-icon" />
								Submit
							</Button>
							<Button variant="danger" onClick={handleClose} className="ml-3">
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
					{loading ? <Loader /> : null}
				</Form>
			</Modal>
		</section>
	);
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
	loading: state.users.loading,
	login: state.users.login,
	users: state.users.users,
	hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(LoginPage);
